import React from 'react';
import {Card, Grid} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import {numberToHumanSize} from 'spectra-logic-ui/helpers/number';

import TextField from '@/components/form/text_field';
import FormSingleSelect from '@/components/form/single_select';

const useStyles = makeStyles({
  root: {
    padding: 15,
    marginTop: 10,
  },
  grid: {
    '& > *': {
      marginBottom: 10,
    },
  },
});

export type ItemDetails = {
  size: number;
  used: number;
}

const QuotaCard = (props: {itemDetails: ItemDetails} ) => {
  const classes = useStyles();
  let poolSize = '';
  if (props.itemDetails !== undefined) {
    poolSize = numberToHumanSize(props.itemDetails.size);
    poolSize = poolSize + ' available';
  }

  const QuotaTooltip = 'Set the maximum amount of storage to use. ' +
    'No more data will be put on the storage once this value is reached. ' +
    'This values can be changed at a later time. ' +
    'Leave blank for no quota.';
  const unitOptions = [{
    key: 'MiB',
    text: 'MiB',
  }, {
    key: 'GiB',
    text: 'GiB',
  }, {
    key: 'TiB',
    text: 'TiB',
  }, {
    key: 'PiB',
    text: 'PiB',
  }];
  return (
    <Card className={classes.root}>
      <Grid container spacing={2} className={classes.grid}>
        <Grid item xs={6}>
          <TextField
            name='quota'
            label='Quota'
          />
        </Grid>
        <Grid item xs={6}>
          <FormSingleSelect name='units' label='Units'
            options={unitOptions}
            tooltip={QuotaTooltip}
          />
        </Grid>
        <Grid item xs={12}>
          <p>{poolSize}</p>
        </Grid>
      </Grid>
    </Card>
  );
};

export default QuotaCard;
